module.exports = __webpack_public_path__ + "static/media/g.7c46c83e.svg";